{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Chargement de l'éditeur...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT": "Bot système",
    "GLOBAL_BOT_BADGE": "Système",
    "AVATAR": {
      "SUCCESS_DELETE": "Avatar du bot supprimé avec succès",
      "ERROR_DELETE": "Erreur lors de la suppression de l'avatar du bot, veuillez réessayer"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Sélectionnez un bot d'agent",
      "DESC": "Assignez un robot d'agent à votre boîte de réception. Ils peuvent gérer les conversations initiales et les transférer à un agent en direct si nécessaire.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Mettre à jour",
      "DISCONNECT": "Déconnecter le bot",
      "SUCCESS_MESSAGE": "Le bot agent a été mis à jour avec succès.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Déconnexion réussie du bot agent.",
      "ERROR_MESSAGE": "Impossible de mettre à jour le bot de l'agent. Veuillez réessayer.",
      "DISCONNECTED_ERROR_MESSAGE": "Impossible de déconnecter le bot de l'agent. Veuillez réessayer.",
      "SELECT_PLACEHOLDER": "Sélectionner le bot",
      "COUNTRY_BOTS": {
        "TITLE": "Bots par pays",
        "DESC": "Cette boîte de réception dessert plusieurs pays. Une conversation est dirigée vers le bot de son pays : selon la boutique Kaufland, la place de marché de la commande Allegro ou, à défaut, la langue dans laquelle écrit le client. Toutes les autres conversations vont au bot par défaut ci-dessus.",
        "COUNTRY": "Sélectionner un pays",
        "BOT": "Sélectionner le bot",
        "ADD": "Ajouter un bot pour un pays",
        "REMOVE": "Supprimer",
        "DEFAULT_REQUIRED": "Sélectionnez d'abord un bot par défaut. Le bot d'un pays ne le remplace que pour ce pays.",
        "DISCONNECT_ALL": "Déconnecter tous les bots"
      }
    },
    "ADD": {
      "TITLE": "Configurer le nouveau bot",
      "CANCEL_BUTTON_TEXT": "Annuler",
      "API": {
        "SUCCESS_MESSAGE": "Le bot a été ajouté avec succès.",
        "ERROR_MESSAGE": "Impossible d'ajouter le bot, veuillez réessayer plus tard."
      }
    },
    "LIST": {
      "404": "Aucun Bots trouvé, vous pouvez créer un bot en cliquant sur le bouton 'Configurer un nouveau bot' ↗️",
      "LOADING": "Récupération des bots...",
      "TABLE_HEADER": {
        "DETAILS": "Détails du bot",
        "URL": "URL du webhook"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Supprimer",
      "TITLE": "Supprimer le bot",
      "CONFIRM": {
        "TITLE": "Confirmer la suppression",
        "MESSAGE": "Êtes-vous sûr de vouloir supprimer {name} ?",
        "YES": "Oui, supprimer",
        "NO": "Non, conserver"
      },
      "API": {
        "SUCCESS_MESSAGE": "Bot supprimé avec succès.",
        "ERROR_MESSAGE": "Impossible de supprimer le bot. Veuillez réessayer."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Modifier",
      "TITLE": "Modifier le bot",
      "API": {
        "SUCCESS_MESSAGE": "Bot mis à jour avec succès.",
        "ERROR_MESSAGE": "Impossible de mettre à jour le bot, veuillez réessayer plus tard."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Avatar du bot"
      },
      "NAME": {
        "LABEL": "Nom du bot",
        "PLACEHOLDER": "Entrez le nom du bot",
        "REQUIRED": "Le nom du bot est requis"
      },
      "DESCRIPTION": {
        "LABEL": "Description",
        "PLACEHOLDER": "Que fait ce bot ?"
      },
      "WEBHOOK_URL": {
        "LABEL": "URL du webhook",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "L'URL du webhook est requise"
      },
      "ERRORS": {
        "NAME": "Le nom du bot est requis",
        "URL": "L'URL du webhook est requise",
        "VALID_URL": "Veuillez entrer une URL valide commençant par http:// ou https://"
      },
      "CANCEL": "Annuler",
      "CREATE": "Créer le bot",
      "UPDATE": "Mettre à jour le bot"
    },
    "WEBHOOK": {
      "DESCRIPTION": "Configurez un bot webhook pour vous intégrer à vos services personnalisés. Le bot recevra et traitera les événements des conversations et pourra y répondre."
    },
    "TYPES": {
      "WEBHOOK": "Webhook Bot"
    }
  }
}
